import React, {Component} from 'react';
import {Container as FluxContainer} from "flux/utils";
import {loginFromHomePageRequestReceived} from "./Actions";
import {isAuthenticated} from "../../services/self";
import LoginFromHomePageView from "./components/LoginFromHomePageView";
import LoginFromHomePageStore from "./LoginFromHomePageStore";
import {Redirect} from "react-router-dom";

class LoginFromHomePage extends Component {
    static getStores() {
        return [LoginFromHomePageStore];
    }

    static calculateState() {
        return LoginFromHomePageStore.getState();
    }

    componentWillMount() {
        const authenticated = isAuthenticated() === true;
        loginFromHomePageRequestReceived(authenticated)
    }

    render() {
        const displayAuthenticationModal = this.state.displayAuthenticationModal;
        if (displayAuthenticationModal) {
            return (
                <LoginFromHomePageView formDisabled={this.state.formDisabled}
                                       email={this.state.email}
                                       password={this.state.password}
                                       formInfoMessage={this.state.formInfoMessage}
                                       formErrorMessage={this.state.formErrorMessage}/>
            )
        }else {
            setTimeout(function(){
                window.location.reload();
            });
            return <Redirect to={window.location.pathname}/>;
        }
    }
}

export default FluxContainer.create(LoginFromHomePage);


/** WEBPACK FOOTER **
 ** ./src/shared_states/LoginFromHomePageRequest/LoginFromHomePage.js
 **/